import { RequestStep } from './RequestStep';
import { VerificationStep } from './VerificationStep';
import { CustomerAuthChallengeStatus } from '@servicetitan/financing-api-client';

interface CustomerAuthRendererProps {
    currentStep: 'request' | 'verification' | 'success';

    challengeStatus: CustomerAuthChallengeStatus | null;
    onBack?: () => void;
    onSubmitVerification: () => void;
    onRequestSuccess: (challengeData: CustomerAuthChallengeStatus) => void;
    onChallengeStatusUpdate: (challengeData: CustomerAuthChallengeStatus) => void;
}

export const CustomerAuthRenderer = ({
    currentStep,
    challengeStatus,
    onBack,
    onSubmitVerification,
    onRequestSuccess,
    onChallengeStatusUpdate,
}: CustomerAuthRendererProps) => {
    const renderStep = () => {
        switch (currentStep) {
            case 'request':
                return <RequestStep onSuccess={onRequestSuccess} onBack={onBack} />;
            case 'verification':
                return (
                    <VerificationStep
                        challengeStatus={challengeStatus}
                        onSuccess={onSubmitVerification}
                        onChallengeStatusUpdate={onChallengeStatusUpdate}
                        onBack={onBack}
                    />
                );
        }
    };

    return renderStep();
};
